import { createAsyncThunk } from '@reduxjs/toolkit';
import { setDeleteAttachment } from '../../utils/setDeleteAttachment';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const deleteAttachment = createAsyncThunk(
    'bulletins/deleteAttachment',
    async (filePermissionId, { getState }) => {
        const state = getState();

        const selectedProjectId = selectSelectedProjectId(state);

        const deletedAttachment = await setDeleteAttachment(filePermissionId, selectedProjectId);

        return { deletedAttachment };
    }
);